import { create } from "zustand";
import {
    clearHouseIdentity,
    loadHouseIdentity,
    saveHouseIdentity,
    type HouseIdentity,
} from "@/api/identity";

/**
 * 가문(익명 유저) 세션. localStorage 에서 initial 을 끌어오고, 이후 로그인/발급 결과를 반영.
 */

interface SessionState {
    identity: HouseIdentity | null;
    ready: boolean;
}

interface SessionActions {
    bootstrap: () => void;
    setIdentity: (identity: HouseIdentity) => void;
    clear: () => void;
}

export const useSession = create<SessionState & SessionActions>((set) => ({
    identity: null,
    ready: false,

    bootstrap: () => {
        const loaded = loadHouseIdentity();
        set({ identity: loaded, ready: true });
    },

    setIdentity: (identity) => {
        saveHouseIdentity(identity);
        set({ identity });
    },

    clear: () => {
        clearHouseIdentity();
        set({ identity: null });
    },
}));
